import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import {LOADING_STATES} from '@Libraries/email-marketing-campaigns-library';
import {emailMarketingCampaignSettingsExtraReducers} from './email-marketing-campaign-settings-extra-reducers';
import type {EmailMarketingCampaignSettingsState} from './email-marketing-campaign-settings.types';

const initialState: EmailMarketingCampaignSettingsState = {
  settingsLoadingState: LOADING_STATES.NOT_LOADED,
  senderProfiles: {},
  emailSends: 0,
  credits: null,
  defaultSenderProfileId: null,
  accountEmail: '',
  domainAuthenticationDetails: {},
  physicalAddress: null,
};

const emailCampaignSettingsSlice = createSlice({
  name: 'emailCampaignSettings',
  initialState,
  reducers: {
    updateEmailSends: (state, action: PayloadAction<number>) => {
      state.emailSends = action.payload;
    },
    updateSettingsLoadingState: (state, action: PayloadAction<number>) => {
      state.settingsLoadingState = action.payload;
    },
  },
  extraReducers: emailMarketingCampaignSettingsExtraReducers,
});

export const {updateEmailSends, updateSettingsLoadingState} = emailCampaignSettingsSlice.actions;
export const emailMarketingCampaignSettingsReducer = emailCampaignSettingsSlice.reducer;
